const getters = {
  isLogin: state => state.user.isLogin,
}
export default getters
